import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Facebook, Linkedin } from 'lucide-react';
import { LANDING } from '@/constants/testIds';
import Logo from './Logo';

const Footer = () => (
    <footer id="contacto" className="relative border-t border-white/10 pt-24 pb-10 overflow-hidden bg-[color:var(--surface)]">
        <div className="relative mx-auto max-w-[1440px] px-6 md:px-10">
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7 }}
                className="grid grid-cols-12 gap-5 md:gap-8 pb-16 border-b border-white/10"
            >
                <div className="col-span-12 md:col-span-8">
                    <div className="eyebrow-brand mb-6">La próxima salida</div>
                    <h2 className="font-display text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95]">
                        Alístate.<br />
                        <span className="italic-accent text-[color:var(--brand)] font-normal">Los cupos vuelan.</span>
                    </h2>
                </div>
                <div className="col-span-12 md:col-span-4 flex flex-col justify-end gap-4">
                    <p className="text-white/75 leading-relaxed">
                        Únete a la Tribu. Agenda tu sesión de orientación hoy y validamos si esta misión
                        es el paso correcto para tu empresa.
                    </p>
                </div>
            </motion.div>

            <div className="grid grid-cols-12 gap-5 md:gap-8 mt-14">
                <div className="col-span-12 md:col-span-5">
                    <div className="eyebrow-brand mb-4">Contacto directo</div>
                    <div className="font-display text-white text-3xl md:text-4xl mb-2">
                        Mariale Latorre
                    </div>
                    <div className="text-white/60 mb-6">Programa Misión FITUR 2027</div>
                    <div className="flex flex-col gap-3 text-sm">
                        <a data-testid={LANDING.footerEmail} href="mailto:mlatorre@incubatour.com" className="link-underline text-white/85 hover:text-white">
                            mlatorre@incubatour.com
                        </a>
                        <a data-testid={LANDING.footerWhatsapp} href="https://wa.me/573158475169" target="_blank" rel="noopener noreferrer" className="link-underline text-white/85 hover:text-white">
                            +57 315 847 5169 · WhatsApp
                        </a>
                        <a href="https://lab.incubatour.com/" target="_blank" rel="noopener noreferrer" className="link-underline text-white/85 hover:text-white">
                            lab.incubatour.com — otras misiones
                        </a>
                        <a data-testid={LANDING.footerWebsite} href="https://www.incubatour.com" target="_blank" rel="noopener noreferrer" className="link-underline text-white/85 hover:text-white">
                            www.incubatour.com
                        </a>
                    </div>
                    <div className="flex items-center gap-3 mt-7">
                        <a
                            data-testid={LANDING.footerSocialInstagram}
                            href="https://www.instagram.com/incubatour"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram de Incubatour"
                            className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-white/70 hover:border-[color:var(--brand)] hover:text-white transition-colors"
                        >
                            <Instagram size={16} />
                        </a>
                        <a
                            data-testid={LANDING.footerSocialFacebook}
                            href="https://www.facebook.com/incubatour"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Facebook de Incubatour"
                            className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-white/70 hover:border-[color:var(--brand)] hover:text-white transition-colors"
                        >
                            <Facebook size={16} />
                        </a>
                        <a
                            data-testid={LANDING.footerSocialLinkedin}
                            href="https://www.linkedin.com/company/incubatour"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="LinkedIn de Incubatour"
                            className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-white/70 hover:border-[color:var(--brand)] hover:text-white transition-colors"
                        >
                            <Linkedin size={16} />
                        </a>
                    </div>
                </div>

                <div className="col-span-6 md:col-span-3">
                    <div className="eyebrow-brand mb-4">Coordenadas</div>
                    <ul className="space-y-3 text-sm text-white/75">
                        <li>Madrid, España</li>
                        <li>FITUR · IFEMA</li>
                        <li>20 · Ene · 2027</li>
                        <li>Salida LATAM · Español</li>
                    </ul>
                </div>

                <div className="col-span-6 md:col-span-3">
                    <div className="eyebrow-brand mb-4">Legal</div>
                    <ul className="space-y-3 text-sm text-white/75">
                        <li>RNT · 278668</li>
                        <li>© Incubatour {new Date().getFullYear()}</li>
                        <li>La Tribu · Todos los derechos</li>
                    </ul>
                </div>
            </div>

            <div className="mt-14 md:mt-20 border-t border-white/10 pt-10 flex items-end justify-between gap-6">
                <div>
                    <Logo size={96} />
                    <div className="mt-4 text-xs uppercase tracking-[0.2em] text-white/40">
                        Ed. FITUR 27 · Salida LATAM
                    </div>
                </div>
                <div className="hidden md:block overline text-white/40 pb-2">Made in Bogotá · Con la Tribu</div>
            </div>
        </div>
    </footer>
);

export default Footer;
